import { useEffect, useState } from "react";
import { Qualifier, QualifierFragment } from "fe-common/graphql";
import { useDaoContext } from "fe-web-components/diseaseview/DaoContext";
import { Relations } from "shared";

export const useSearchQualifiers = (id: string, relationIds: string[] = []) => {
  const [qualifiers, setQualifiers] = useState<QualifierFragment[]>([]);
  const [loading, setLoading] = useState(false);
  const webDao = useDaoContext();

  const relationsIdStr = relationIds?.toString();

  useEffect(() => {
    (async () => {
      if (!id) return null;

      setLoading(true);
      let qualifiers: Qualifier[] = await webDao.searchQualifiers("", id, "");

      if (relationIds.length)
        qualifiers = qualifiers?.filter((q) =>
          relationIds.includes(q.relation.id),
        );

      qualifiers = qualifiers?.filter(
        (q) => q.relation.id !== Relations.DURATION,
      );

      setQualifiers(qualifiers || []);
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webDao, id, relationsIdStr]); //no need for new relations array if the QF and relationsIds did not change

  return { qualifiers: qualifiers, loading: loading };
};
